module.exports = __webpack_public_path__ + "static/ror-distance-bf57cd0975661f3c0ed86265ae45083b.svg";